import React from "react";
import { analyzePRWeek } from "./StatsWeek";
import { Chart, Filler } from "chart.js";
import { Line } from "react-chartjs-2";
import { getWeek } from "./App";

Chart.register(Filler);


class StatsPersonal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadCount: 0,
      userW: 0,
      userL: 0,
      myRank: -1, // x / numLeagueSize
      myPicksOrganized: [],
      cash: this.props.cash,
      picksForMe: -1,
      picksAgainstMe: -1,
      whoLovesMe: [],
      whoHatesMe: [],
      key1: "most",
      key2: "most",
      myMostPicked: [],
      myLeastPicked: [],
      animated: false,
      rankGraph: [],
      rankGraphOptions: [],
    };
    this.r1 = React.createRef();
    this.r2 = React.createRef();
    this.r3 = React.createRef();
    this.r4 = React.createRef();
    this.r5 = React.createRef();
    this.r6 = React.createRef();
    this.r7 = React.createRef();
  }

  componentDidMount() {
    if (this.state.loadCount == 0) {
      this.calcData();
      // this.getTable1();
      // this.getTable2();
      this.setState({ loadCount: this.state.loadCount++ });
    }
    if (this.state.rankGraph.length == 0) {
      this.createRankPlot();
    }
  }

  async calcData() {
    this.setState({ animated: true });
    //----- get record rank

    let avgs = this.props.recordsArr
      .map((record, i) => {
        if (record[1] == 0) {
          let tmp = [];
          tmp.push(-1, i);
        }
        let tmp = [];
        tmp.push((record[0] * 1.0) / record[1], i);
        return tmp;
      })
      .filter((record) => record[0] > 0)
      .sort((a, b) => b[0] - a[0]);

    let myScore = avgs
      .filter((a) => a[1] == this.props.myIndex)

      .map((a) => {
        return a[0];
      });
    let myRank = -1;
    let tied = "";

    for (let i = 0; i < avgs.length; i++) {
      if (avgs[i][0] == myScore) {
        myRank = i + 1;
        if (
          avgs[i][1] != this.props.myIndex ||
          (i != avgs.length - 1 && avgs[i + 1][0] == myScore)
        ) {
          tied = "T";
        }
      }
    }

    // -------- get most and least voted for

    let most = [];
    let least = [];

    let high = -1;
    let low = 100;

    let myPicksOrganized = [...this.props.whoIPick];
    myPicksOrganized.splice(myPicksOrganized.length - 1);
    myPicksOrganized = myPicksOrganized
      .map((team, index) => {
        let tmp = [];
        tmp.push(team);
        tmp.push(index);
        return tmp;
      })
      .sort((a, b) => b[0] - a[0]);

    most.push(myPicksOrganized[0], myPicksOrganized[1], myPicksOrganized[2]);
    least.push(
      myPicksOrganized[myPicksOrganized.length - 1],
      myPicksOrganized[myPicksOrganized.length - 2],
      myPicksOrganized[myPicksOrganized.length - 3]
    );

    //-------- picks for and against me

    let forMe = this.props.whoEveryonePicks[this.props.myIndex];
    let againstMe = this.props.pickEmResults.length - forMe;

    //-------- who picks me the msot and least

    let loveMe = [];
    let hateMe = [];

    let h = -1;
    let l = 100;

    let pickPercentage = this.props.whoEachPersonPicks.map((a, index) => {
      if (a[this.props.whoEachPersonPicks.length] == 0) {
        return -1;
      }

      let tmp = [];
      let tmp1 = [];
      tmp.push(
        (a[this.props.myIndex] * 1.0) / a[this.props.whoEachPersonPicks.length]
      );
      tmp.push(index);
      tmp1.push(a[this.props.myIndex] * 1.0);
      tmp1.push(a[this.props.whoEachPersonPicks.length]);
      tmp.push(tmp1);

      return tmp;
    });

    let sortedPickPercentage = pickPercentage
      .sort((a, b) => {
        if (b == -1) {
          return -1;
        }
        if (b[0] == a[0]) {
        }
        return b[0] - a[0];
      })
      .filter((n) => n[0] >= 0);

    let findBest = sortedPickPercentage
      .filter((n) => n[0] == sortedPickPercentage[0][0])
      .sort((a, b) => {
        return (
          this.props.whoEachPersonPicks[b[1]][
            this.props.whoEachPersonPicks.length
          ] -
          this.props.whoEachPersonPicks[a[1]][
            this.props.whoEachPersonPicks.length
          ]
        );
      });

    loveMe = [...sortedPickPercentage];

    for (let i = 0; i < findBest.length; i++) {
      loveMe[i] = [...findBest[i]];
    }

    let findWorst = sortedPickPercentage
      .filter(
        (n) => n[0] == sortedPickPercentage[sortedPickPercentage.length - 1][0]
      )
      .sort((a, b) => {
        return (
          this.props.whoEachPersonPicks[b[1]][
            this.props.whoEachPersonPicks.length
          ] -
          this.props.whoEachPersonPicks[a[1]][
            this.props.whoEachPersonPicks.length
          ]
        );
      });

    hateMe = sortedPickPercentage.sort((a, b) => {
      return a[0] - b[0];
    });

    for (let i = 0; i < findWorst.length; i++) {
      hateMe[i] = [...findWorst[i]];
    }

    if (this.props.whoIPick.filter((a) => a > 0).length == 0) {
      least = [];
      most = [];
    }

    this.setState({
      myRank: tied + myRank,
      myPicksOrganized: myPicksOrganized,
      myMostPicked: most,
      myLeastPicked: least,
      picksForMe: forMe,
      picksAgainstMe: againstMe,
      whoLovesMe: loveMe,
      whoHatesMe: hateMe,
    });
  }

  relationshipCard(kind) {
    const outgoing = kind === "outgoing";
    const stateKey = outgoing ? "key1" : "key2";
    const mode = this.state[stateKey];
    const rows = outgoing
      ? (mode === "most" ? this.state.myMostPicked : this.state.myLeastPicked)
      : (mode === "most" ? this.state.whoLovesMe : this.state.whoHatesMe);
    return <section className="personal-card">
      <header className="personal-card-heading">
        <div><h3>{outgoing ? "Teams you pick" : "Who picks you"}</h3>
          <p>{outgoing ? "Where you put your confidence." : "The league's confidence in your team."}</p></div>
        <div className="personal-toggle" role="group" aria-label={outgoing ? "Teams you pick" : "Who picks you"}>
          {["most", "least"].map(value => <button key={value} type="button" aria-pressed={mode === value}
            onClick={() => this.setState({ [stateKey]: value })}>{value === "most" ? "Most" : "Least"}</button>)}
        </div>
      </header>
      <ol className="personal-team-list">
        {rows.filter(Boolean).slice(0, 3).map((row, index) => {
          const count = outgoing ? row[0] : row[2][0];
          const total = outgoing ? this.props.whoIPick[this.props.whoIPick.length - 1] : row[2][1];
          const percent = total ? Math.round(count / total * 100) : null;
          return <li key={row[1]}>
            <span className="personal-list-number">{index + 1}</span>
            <div className="personal-team-detail"><strong>{this.props.nameIdArr[row[1]][1]}</strong>
              <span>{count} of {total} pick cards</span></div>
            <strong className="personal-percentage">{percent === null ? "—" : `${percent}%`}</strong>
          </li>;
        })}
      </ol>
      {!rows.filter(Boolean).length && <p className="personal-empty">No picks to compare yet.</p>}
    </section>;
  }

  async createRankPlot() {
    let week = getWeek();
    let myId = this.props.nameIdArr[this.props.myIndex][0];

    let allData = this.props.nameIdArr.map(t => [t[0], t[1]]);
    let currentValid = 0;

    if (
      this.props.rankingData.filter((r) => r.Week == week).length > 1 ||
      (this.props.rankingData.filter((r) => r.Week == week).length == 1 &&
        this.props.rankingData.filter((r) => r.Week == week)[0].Tid !== myId)
    ) {
      // >1 because two are needed for all 10 ranked
      currentValid = 1;
    }

    for (let i = 1; i < week + currentValid; i++) {
      let weekRanks = analyzePRWeek(
        this.props.rankingData.filter((r) => r.Week == i),
        ...this.props.nameIdArr
      );

      weekRanks = weekRanks.map((r,i) => [i+1, ...r])

      allData = allData.map((team) => {
        if (weekRanks.filter(r => r[1] === team[0]).length > 0) {
          return [...team, weekRanks.filter(r => r[1] === team[0])[0][0]];
        }
        else {
          return [...team, -1];
        }
      });
    }

    allData = allData.filter(
      (t) => t[0] === this.props.nameIdArr[this.props.myIndex][0]
    );

    //the rank of each team each week

    let options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
      },
      scales: {
        y: {
          reverse: true,
          ticks: { stepSize: 1 },
          title: {
            display: "true",
            text: "Rank",
          },
          min: 1,
          max: 10,
        },
        x: {
          title: {
            display: "true",
            text: "Week",
          },
        },
      },
    };
    let labels = [];

    for (let i = 1; i < week + currentValid; i++) {
      labels.push(i);
    }

    let data = {
      labels,
      scale: "reverse",
      datasets: allData.map((team, ind, arr) => {
        let d = [...team];
        d = d.slice(2);

        return {
          label: team[1],
          data: d.map(value => value < 1 ? null : value),
          borderColor: "#247d82",
          backgroundColor: "#247d82",
          tension: 0.1,
          fill: false,
          pointRadius: 5,
          pointHoverRadius: 7,
          borderWidth: 2,
        };
      }),
    };

    this.setState({ rankGraph: data, rankGraphOptions: options });
  }

  render() {
    const [correct, incorrect] = this.props.recordsArr[this.props.myIndex] || [0, 0];
    const accuracy = correct + incorrect ? `${Math.round(correct / (correct + incorrect) * 100)}%` : "—";
    const forMe = Math.max(0, this.state.picksForMe);
    const againstMe = Math.max(0, this.state.picksAgainstMe);
    const support = forMe + againstMe ? Math.round(forMe / (forMe + againstMe) * 100) : null;
    const cash = this.props.cash || [0, 0, 0];
    return <div id="pContainer" className="personal-stats">
      <header className="personal-intro"><span className="personal-eyebrow">Your season</span>
        <h2>{this.props.nameIdArr[this.props.myIndex][1]}</h2>
        <p>Your picks, your supporters, and your place in the league.</p>
      </header>
      <div className="personal-summary">
        <section className="personal-metric personal-metric-primary"><h3>Pick accuracy</h3><strong>{accuracy}</strong><p>{correct} correct · {incorrect} incorrect</p></section>
        <section className="personal-metric"><h3>Pick 'em rank</h3><strong>{correct + incorrect && this.state.myRank !== "-1" ? this.state.myRank : "—"}</strong><p>By pick record</p></section>
        <section className="personal-metric"><h3>League confidence</h3><strong>{support === null ? "—" : `${support}%`}</strong><p>{forMe} picks for you · {againstMe} against</p></section>
      </div>
      <div className="personal-relationships">{this.relationshipCard("outgoing")}{this.relationshipCard("incoming")}</div>
      <section className="personal-card personal-faab">
        <div><h3>Your pick 'em FAAB</h3><p>Recorded rewards and penalties. Challenge FAAB is shown in Challenges.</p></div>
        <dl><div><dt>Pick cards</dt><dd>${cash[0]}</dd></div><div><dt>Rankings</dt><dd>${cash[2]}</dd></div><div><dt>Wins & penalties</dt><dd>${cash[1]}</dd></div></dl>
      </section>
      <section className="personal-card">
        <header className="personal-card-heading"><div><h3>Your power ranking</h3><p>How the league ranks your team each week.</p></div></header>
        {this.state.rankGraph?.datasets ? <div className="personal-chart"><Line options={this.state.rankGraphOptions} data={this.state.rankGraph} aria-label="Your power ranking by week" role="img" /></div> : <p className="personal-empty">Your ranking will appear after ballots are submitted.</p>}
      </section>
    </div>;
  }
}

export default StatsPersonal;
